export function stringifyObjectShallow(object: object) {
  if (typeof object !== 'object') {
    return JSON.stringify(object);
  }
  if (Array.isArray(object)) {
    return `[]`;
  }
  return `{ ${Object.keys(object).join(', ')} }`;
}
